<script lang="ts">
  import { onMount } from "svelte";
  import type { Props } from "./IconV1.types";
  import { useHost } from "../../../common/runtime/utils/useHost.ts";

  let { color = undefined, ocAriaLabel = undefined, type }: Props = $props();
  let animatedWishlistActiveHighlight = $state("");
  let Host = useHost();

  const preload = async (): Promise<void> => {
    if (animatedWishlistActiveHighlight) {
      return;
    }

    animatedWishlistActiveHighlight = (
      await import("./animatedSVG/animatedWishlistActiveHighlight.svg?raw")
    ).default;
  };

  $effect(() => {
    if (type === "animated-wishlist-active-highlight") {
      let current = true;
      preload().then(() => {
        if (current) Host.innerHTML = animatedWishlistActiveHighlight;
      });
      return () => (current = false);
    } else {
      Host.innerHTML = "";
    }
  });

  $effect(() => {
    if (color) {
      Host.style.setProperty("--color", color);
    } else {
      Host.style.removeProperty("--color");
    }
  });

  onMount(() => {
    /*                                                                                                */
    if (type === "wishlist") {
      preload();
    }
  });

  /*                          */
  $effect(() => {
    if (ocAriaLabel) {
      Host.setAttribute("aria-label", ocAriaLabel);
      Host.role = "img";
    }
  });
</script>
